<template>
    <nav class="navbar navbar-expand-lg navbar-expand-sm navbar-expand navbar-light bg-light mt-1 mb-1 " >
        <a class="navbar-brand" :href="item.alias">
            {{item.title}}
        </a>
        <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
            <ul class="navbar-nav mr-auto mt-0 mt-lg-0"></ul>
            <a :href="item.alias" class="width-3 height-2 d-inline-flex align-items-center justify-content-center position-relative h1 mr-1 mb-0">

                <div class='icon-stack fs-xxl'>
                    <i class="base base-9 icon-stack-3x opacity-100 color-primary-300"></i>
                    <i class="fal fa-digging icon-stack-1x opacity-100 color-white"></i>
                </div>
                <span class="badge badge-icon pos-top pos-right">
                    {{animatedNumber}}
                </span>
            </a>
        </div>
    </nav>
</template>

<script>
    import { TweenLite } from 'greensock';

    export default {
        name: "menu_item",
        props: {
            item: {
                type: Object,
                default: () => {
                
                }
            },
        },

        created() {
            EventBus.$on('mem_count_ready',this.setMemCount)
        },

        data() {
            return  {
                mem_anim_count: 0
            }
        },

        methods : {
            setMemCount(menus_count) {
                let self = this;
                if(menus_count.length > 0) {
                    menus_count.map(menu_item => {
                        let menu_item_id = self.item.id;
                        if(parseInt(menu_item.menu_id) === parseInt(menu_item_id)) {
                            self.item.mem_count = parseInt(menu_item.menu_count);
                        }
                    })
                }
            },
        },

        computed: {
            animatedNumber: function() {
                return this.mem_anim_count.toFixed(0);
            }
        },
        watch : {
            'item.mem_count': function(newValue) {
                TweenLite.to(this.$data, 0.5, { mem_anim_count: newValue });
            }


        },

    }
</script>

<style scoped>

</style>
